import rawGrammer from "./grammer.json";

export class NlpCache {
  positiveNegativeCache: Record<string, { positiveDescription: string; negativeDescription: string }> = {};
}

export type ProcessedGrammer = {
  words: Array<{
    type: "positive" | "negative";
    reverse: string;
    regexp: RegExp;
    text: string;
  }>;
};

const ensureGrammer = (language: string): ProcessedGrammer => {
  const grammer = rawGrammer as any;
  if (!grammer[language]) {
    throw new Error(`Language ${language} not supported`);
  }
  if (!grammer.processed) {
    grammer.processed = {};
  }

  if (grammer.processed[language]) {
    return grammer.processed[language];
  }

  const rawWords = grammer[language];
  const processedGrammer: ProcessedGrammer = {
    words: [],
  };
  const orderedKeys = Object.keys(rawWords).sort((a, b) => b.length - a.length);
  for (const word of orderedKeys) {
    const info = rawWords[word];
    processedGrammer.words.push({
      text: word,
      type: info.type,
      reverse: info.reverse,
      regexp: new RegExp(`\\s${word}\\s`),
    });
  }

  return (grammer.processed[language] = processedGrammer);
};

export const getNegativeAndPositiveDescriptions = (cache: NlpCache, description: string) => {
  const cached = cache.positiveNegativeCache[description];
  if (cached) {
    return cached;
  }

  const grammer = ensureGrammer("en");
  for (const word of grammer.words) {
    if (word.regexp.test(description)) {
      if (word.type === "positive") {
        return (cache.positiveNegativeCache[description] = {
          negativeDescription: description.replace(word.text, word.reverse),
          positiveDescription: description,
        });
      }
      if (word.type === "negative") {
        return (cache.positiveNegativeCache[description] = {
          negativeDescription: description,
          positiveDescription: description.replace(word.text, word.reverse),
        });
      }
    }
  }

  return (cache.positiveNegativeCache[description] = {
    negativeDescription: description,
    positiveDescription: description,
  });
};
